import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row sort-and-filter mt-3 mb-3" }
const _hoisted_2 = { class: "col right" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn dropdown-toggle",
  type: "button",
  id: "parkFilterButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, "Park Filter", -1)
const _hoisted_5 = {
  class: "dropdown-menu",
  "aria-labelledby": "parkFilterButton"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row daily-schedule-header" }
const _hoisted_8 = { class: "col-md-6 text-left nav-return-month" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrow-left mr-1" }, null, -1)
const _hoisted_10 = { class: "col-md-6 text-right nav-list-by" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-only" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3" })
], -1)
const _hoisted_12 = { class: "d-inline pr-3 list-by-item" }
const _hoisted_13 = {
  key: 0,
  class: "active"
}
const _hoisted_14 = { class: "d-inline ml-3 list-by-item" }
const _hoisted_15 = {
  key: 0,
  class: "active"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  name: "times-list",
  id: "times-list"
}, null, -1)
const _hoisted_17 = { class: "col-md-6 activity-list" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "events-banner-featured" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "events-banner-all" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "events-banner-all" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("em", null, "No activities are scheduled for this day", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "col-md-6 activity-detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ActivityFeatured = _resolveComponent("ActivityFeatured")!
  const _component_ActivityNonFeatured = _resolveComponent("ActivityNonFeatured")!
  const _component_ActivityTimeNonFeatured = _resolveComponent("ActivityTimeNonFeatured")!
  const _component_ActivityDetail = _resolveComponent("ActivityDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCalendarFilter(null)))
            }, "All"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operatingCalendars, (opCal) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "dropdown-item",
                type: "button",
                key: opCal.operatingExtCalendarId,
                onClick: ($event: any) => (_ctx.changeCalendarFilter(opCal.operatingExtCalendarId))
              }, _toDisplayString(opCal.displayName), 9, _hoisted_6))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: _ctx.returnUrl,
          replace: ""
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" Return to Month View ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isByTime)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "List By Time"))
            : _createCommentVNode("", true),
          (!_ctx.isByTime)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: _ctx.byTimeUrl,
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("List By Time")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.isByTime)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "List By Activity"))
            : _createCommentVNode("", true),
          (_ctx.isByTime)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: _ctx.byActivityUrl,
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("List By Activity")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", {
      class: _normalizeClass(["row", { 'loading': _ctx.isLoading }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        (_ctx.activities.featuredActivities.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.calendarPageContent.featuredEventsHeadline), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities.featuredActivities, (schedule) => {
                return (_openBlock(), _createBlock(_component_ActivityFeatured, {
                  key: schedule.extCalendarId,
                  "activity-day-schedule": schedule,
                  onActivitySelected: _ctx.changeSelectedActivity
                }, null, 8, ["activity-day-schedule", "onActivitySelected"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activities.nonFeaturedActivities.length && !_ctx.isByTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.calendarPageContent.allActivitiesHeadline), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities.nonFeaturedActivities, (schedule) => {
                return (_openBlock(), _createBlock(_component_ActivityNonFeatured, {
                  key: schedule.extCalendarId,
                  "activity-day-schedule": schedule,
                  onActivitySelected: _ctx.changeSelectedActivity
                }, null, 8, ["activity-day-schedule", "onActivitySelected"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activities.nonFeaturedActivityTimes.length && _ctx.isByTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.calendarPageContent.allActivitiesHeadline), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities.nonFeaturedActivityTimes, (activityTime) => {
                return (_openBlock(), _createBlock(_component_ActivityTimeNonFeatured, {
                  key: activityTime.sortKey,
                  "activity-day-schedule": activityTime.activity,
                  "time-slot": activityTime.schedule,
                  onActivitySelected: _ctx.changeSelectedActivity
                }, null, 8, ["activity-day-schedule", "time-slot", "onActivitySelected"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hasVisibleActivities)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
          : _createCommentVNode("", true)
      ]),
      (_ctx.hasVisibleActivities)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_ctx.selectedActivity !== null && _ctx.selectedActivitySchedule !== null)
              ? (_openBlock(), _createBlock(_component_ActivityDetail, {
                  key: 0,
                  activity: _ctx.selectedActivity!,
                  schedule: _ctx.selectedActivitySchedule!
                }, null, 8, ["activity", "schedule"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}